export const SHOW_ORDER_ON_CHART = process.env.REACT_APP_FEATURE_FLAG_SHOW_ORDER_ON_CHART;
export const ORDER_PLACED_FROM_CHARTS =
  process.env.REACT_APP_FEATURE_FLAG_ORDER_PLACED_FROM_CHARTS;
